const canUseDOM = !!(
  typeof window !== `undefined` &&
  window.document &&
  window.document.createElement
)

const LOCAL_DOMAIN = `localhost`
const STAGING_DOMAIN = `staging.wolfandbadger.com`
const PRODUCTION_DOMAIN = `www.wolfandbadger.com`
const SUPPORT_DOMAIN = `https://support.wolfandbadger.com/`
const CUSTOMER_SUPPORT_FORM = `https://contact.wolfandbadger.com/customer`
const B_CORP_URL = `https://www.bcorp.com/`
const TRUSTPILOT_URL = `https://uk.trustpilot.com/review/www.wolfandbadger.com`
const INSTAGRAM_URL = `http://instagram.com/wolfandbadger`

const generateArticlePath = id =>
  `https://support.wolfandbadger.com/en/article/${id}`

const WHERE_IS_MY_ORDER_ARTICLE = generateArticlePath(`a9fcef`)
const CANCEL_MY_ORDER_ARTICLE = generateArticlePath(`53c7b2`)
const WHERE_IS_MY_REFUND_ARTICLE = generateArticlePath(`e4be0c`)
const HOW_DO_I_RETURN_MY_ORDER_ARTICLE = generateArticlePath(`04655b`)

const getCurrentDomain = () =>
  (canUseDOM && window.location.hostname) || `www.wolfandbadger.com`

const segmentRegionKeys = {
  uk: `G2XvqjxngEoEGE1TCg0jgL6v04AKNUuE`,
  us: `MF0T2XQCFT79K0bGMPZIrfx07EEoirFC`,
  au: `xKbTQKFNV0NTUetEC5AX9Wc4pIIirAdR`,
  ca: `3sivNNsP12cj6oIHwOcRDMDla0PLBLiu`,
  eu: `rMWcHJSl5Xe1CdrG3kF7Tc5oKAbeYHVB`,
  global: `fJuf7NXHQBFUUeZEN4KnMOqkYLbSEFm3`
}

const isLocal = () => getCurrentDomain() === LOCAL_DOMAIN
const isStaging = () => getCurrentDomain() === STAGING_DOMAIN
const isProduction = () => getCurrentDomain() === PRODUCTION_DOMAIN
const isPreviewDeck = () =>
  canUseDOM &&
  window.location.hostname.match(/preview-deck-(.*?).wolfandbadger.com/i) !==
    null

const TOPSORT_WORKER = isProduction()
  ? `wolfandbadger-prod.topsort.workers.dev`
  : `wolfandbadger-sandbox.topsort.workers.dev`

const determineDynamicYieldState = () => {
  if (process.env.GATSBY_ENABLE_DYNAMIC_YIELD) {
    return process.env.GATSBY_ENABLE_DYNAMIC_YIELD === `true`
  } else {
    return true
  }
}

module.exports = {
  NODE_ENV: process.env.NODE_ENV,
  CURRENT_REGION: process.env.GATSBY_REGION,
  CLIENT_CONTENTFUL_ACCESS_TOKEN: `vByXlB79joxayfQufnTVJOZlcUg4qyUT2QASlvLLEh8`,
  IMAGE_ASSETS_URL: `https://res.cloudinary.com/wolfandbadger/image/upload`,
  ALGOLIA_APP_ID: `XO4U4Y7C0T`,
  ALGOLIA_SEARCH_KEY: `bb6097513c7231e0779e90db875b7563`,
  GIFT_UP_SITE_ID: {
    uk: `81432c28-1887-4809-9a38-08dabdb611bd`,
    us: `07ff126b-577b-4220-5393-08dac62de78f`,
    au: `016702af-9895-481a-5592-08db8919cf14`,
    ca: undefined,
    eu: undefined,
    global: undefined
  }[process.env.GATSBY_REGION],
  SEGMENT_ID: process.env.GATSBY_SEGMENT_ID
    ? process.env.GATSBY_SEGMENT_ID
    : segmentRegionKeys[process.env.GATSBY_REGION],
  DYNAMIC_YIELD_STAGING_SECTION_ID: `9880767`,
  DYNAMIC_YIELD_PRODUCTION_SECTION_ID: `9880861`,
  getCurrentEnv: () => {
    const environments = {
      [LOCAL_DOMAIN]: `local`,
      [STAGING_DOMAIN]: `staging`,
      [PRODUCTION_DOMAIN]: `production`
    }
    return (
      (canUseDOM && environments[getCurrentDomain()]) ||
      environments[PRODUCTION_DOMAIN]
    )
  },
  sentryDsnCustomerWebProduction: `https://881fa3da5e004cf9923f23e59bbffc82@o4412.ingest.sentry.io/5525219`,
  sentryDsnCustomerServerStaging: `https://b8f91302e8036b3d01d1cc06f6d3640f@o4412.ingest.us.sentry.io/4509479655243776`,
  sentryDsnCustomerServerProduction: `https://d2995d09cf88294aba9f19986c8044c6@o4412.ingest.us.sentry.io/4509479847198720`,
  isLocal,
  isStaging,
  isProduction,
  isPreviewDeck,
  CONTENTFUL_ACCESS_TOKEN: `6QSEhlhrxuAYfgLIMpHFUDQLcJqpY9KvsasRY_4CVBw`,
  CONTENTFUL_SPACE_ID: `wrfbz9rvi8t0`,
  CONTENTFUL_ENVIRONMENT: `master`,
  RELEASE_NAME: process.env.GATSBY_RELEASE_NAME,
  ALGOLIA_SEARCH_KEYS: {
    algoliaSearchKey: `bb6097513c7231e0779e90db875b7563`,
    rateLimitedSearchKey: `b74cf1c04255441f0a735f5275087403`
  },
  SUPPORT_DOMAIN,
  CUSTOMER_SUPPORT_FORM,
  B_CORP_URL,
  TRUSTPILOT_URL,
  INSTAGRAM_URL,
  WHERE_IS_MY_ORDER_ARTICLE,
  CANCEL_MY_ORDER_ARTICLE,
  WHERE_IS_MY_REFUND_ARTICLE,
  HOW_DO_I_RETURN_MY_ORDER_ARTICLE,
  TOPSORT_WORKER,
  HIDE_OPT_OUT_FIELD_IN_QUALIFYING_REGIONS:
    process.env.GATSBY_HIDE_OPT_OUT_FIELD_IN_QUALIFYING_REGIONS === `true`,
  ENABLE_HOMEPAGE_CTA_BANNER:
    process.env.GATSBY_ENABLE_HOMEPAGE_CTA_BANNER === `true`,
  ENABLE_CHECKOUT_NAME_VALIDATION:
    process.env.GATSBY_ENABLE_CHECKOUT_NAME_VALIDATION === `true`,
  ENABLE_DYNAMIC_YIELD: determineDynamicYieldState(),
  ENABLE_NEW_FEATURE_FLAGGING:
    process.env.GATSBY_ENABLE_NEW_FEATURE_FLAGGING === `true`,
  ENABLE_AFTER_PAY_BANNER:
    process.env.GATSBY_ENABLE_AFTER_PAY_BANNER === `true`,
  ENABLE_PDP_TO_EDITS_V2: process.env.GATSBY_ENABLE_PDP_TO_EDITS_V2 === `true`,
  ENABLE_CMS_SHOP_BY: process.env.GATSBY_ENABLE_CMS_SHOP_BY === `true`,
  ENABLE_NEW_HOMEPAGE_CAROUSELS:
    process.env.GATSBY_ENABLE_NEW_HOMEPAGE_CAROUSELS === `true`,
  ENABLE_ALGOLIA_RECOMMEND_ON_HOMEPAGE:
    process.env.GATSBY_ENABLE_ALGOLIA_RECOMMEND_ON_HOMEPAGE === `true`,
  ENABLE_ALGOLIA_PERSONALISATION:
    process.env.GATSBY_ENABLE_ALGOLIA_PERSONALISATION,
  BRAND_STAR_RATING_V2: process.env.GATSBY_BRAND_STAR_RATING_V2 === `true`,
  ENABLE_SMS_MARKETING_OPT_IN:
    process.env.GATSBY_ENABLE_SMS_MARKETING_OPT_IN === `true`,
  ENABLE_SIGN_IN_MODAL: process.env.GATSBY_ENABLE_SIGN_IN_MODAL === `true`,
  ENABLE_PDP_BADGES: process.env.GATSBY_ENABLE_PDP_BADGES === `true`,
  ENABLE_DECOUPLED_SEARCH_ENGINE:
    process.env.GATSBY_ENABLE_DECOUPLED_SEARCH_ENGINE === `true`,
  HIDE_DIXA_MESSENGER_IN_MINIBAG:
    process.env.GATSBY_HIDE_DIXA_MESSENGER_IN_MINIBAG === `true`,
  ENABLE_SEARCH_ATTRIBUTION:
    process.env.GATSBY_ENABLE_SEARCH_ATTRIBUTION === `true`,
  ENABLE_SEARCH_ATTRIBUTION_WEB_4930:
    process.env.GATSBY_ENABLE_SEARCH_ATTRIBUTION_WEB_4930 === `true`,
  ENABLE_GUEST_IDENTIFY_WEB_5097:
    process.env.GATSBY_ENABLE_GUEST_IDENTIFY_WEB_5097 === `true`,
  ENABLE_ORDER_COMPLETED_ONCE_WEB_5096:
    process.env.GATSBY_ENABLE_ORDER_COMPLETED_ONCE_WEB_5096 === `true`,
  ENABLE_PRODUCT_LIST_NAMES_WEB_5096:
    process.env.GATSBY_ENABLE_PRODUCT_LIST_NAMES_WEB_5096 === `true`,
  ENABLE_ONE_SEARCH_PER_SEARCH_WEB_5096:
    process.env.GATSBY_ENABLE_ONE_SEARCH_PER_SEARCH_WEB_5096 === `true`,
  ENABLE_AD_CLICK_IDS_WEB_5098:
    process.env.GATSBY_ENABLE_AD_CLICK_IDS_WEB_5098 === `true`,
  ENABLE_CHECKOUT_PAYMENT_EVENTS_WEB_5096:
    process.env.GATSBY_ENABLE_CHECKOUT_PAYMENT_EVENTS_WEB_5096 === `true`,
  ENABLE_PRODUCT_EVENT_CATEGORY_WEB_5096:
    process.env.GATSBY_ENABLE_PRODUCT_EVENT_CATEGORY_WEB_5096 === `true`,
  ENABLE_US_SMS_BOX_WEB_5096:
    process.env.GATSBY_ENABLE_US_SMS_BOX_WEB_5096 === `true`,
  ENABLE_TOPSORT_TIMEOUTS_WEB_5096:
    process.env.GATSBY_ENABLE_TOPSORT_TIMEOUTS_WEB_5096 === `true`,
  ENABLE_IDENTITY_RESET_WEB_5097:
    process.env.GATSBY_ENABLE_IDENTITY_RESET_WEB_5097 === `true`,
  ENABLE_RECENTLY_VIEWED: process.env.GATSBY_ENABLE_RECENTLY_VIEWED === `true`,
  ENABLE_SENTRY_NOISE_FILTER:
    process.env.GATSBY_ENABLE_SENTRY_NOISE_FILTER === `true`,
  ENABLE_HOMEPAGE_V2: process.env.GATSBY_ENABLE_HOMEPAGE_V2,
  ENABLE_BURROW_NAVIGATION: process.env.GATSBY_ENABLE_BURROW_NAVIGATION,
  ENABLE_PDP_CONTENT_V2: process.env.GATSBY_ENABLE_PDP_CONTENT_V2
}
